import React from "react";
import { useTranslation } from "react-i18next";
import { LoadingAvatarSkeleton, LoadingSkeleton } from "../common/LoadingSkeleton";

export default function SinglesPartyAttendanceSummary({ event, variant = "desktop" }) {
  const { t } = useTranslation("events");
  const maximum = Number(event?.max_participants || 0);
  const isMobile = variant === "mobile";
  const placeholderCount = maximum > 0 ? Math.min(Math.floor(maximum), 50) : 10;

  const placeholders = (
    <div
      className={
        isMobile
          ? "-mx-[30px] mt-[12px] overflow-x-auto overflow-y-hidden px-[30px] pb-[8px] pt-[3px] scrollbar-hide"
          : "mt-2 w-full min-w-0 overflow-x-auto overflow-y-visible px-1 py-0.5 scrollbar-hide"
      }
      aria-hidden="true"
    >
      <div
        className={`flex w-max min-w-full flex-nowrap gap-[10px] ${
          isMobile ? "justify-start" : "justify-center"
        }`}
      >
        {Array.from({ length: placeholderCount }, (_, index) => (
          <div key={index} className="flex w-[55px] shrink-0 flex-col items-center">
            <LoadingAvatarSkeleton className="h-[55px] w-[55px] opacity-75" />
            <LoadingSkeleton
              className={`mt-[5px] h-[14px] opacity-60 ${isMobile ? "w-[40px]" : "w-[34px]"}`}
            />
          </div>
        ))}
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <section className="mt-[30px] text-white">
        <h2 className="text-[32px] font-medium leading-[34px] text-white">
          {t("participants_section.title", { defaultValue: "Participants" })}
        </h2>
        {placeholders}
        <p className="mt-2 text-[13px] leading-5 text-white/55">
          {t("join_section.singles_party.attendance_private")}
        </p>
      </section>
    );
  }

  return (
    <section className="mb-6 text-center text-white">
      <h2 className="mb-4 text-xl font-bold text-white">
        {t("participants_section.title", { defaultValue: "Participants" })}
      </h2>
      {placeholders}
      <p className="mt-2 text-center text-xs leading-5 text-white/55">
        {t("join_section.singles_party.attendance_private")}
      </p>
    </section>
  );
}
